import { TAbsenceWarningChannel } from 'shared/domain/entities';

export const ABSENCE_WARNING_CHANNEL: TAbsenceWarningChannel = 'SITE';
